import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import dayjs from 'dayjs';
import Link from 'next/link';
import { contactEmail } from 'utils/constants';
import LogoGreen from 'public/images/logo/logo-green-lime.png';

const footerSocials = [
  {
    name: 'OnBoard Instagram',
    icon: 'ri-instagram-line',
    link: 'https://www.instagram.com/onboard.crew.app/',
  },
  {
    name: 'OnBoard TikTok',
    icon: 'ri-tiktok-fill',
    link: 'https://www.tiktok.com/@onboardcrewapp',
  },
  {
    name: 'OnBoard LinkedIn',
    icon: 'ri-linkedin-box-fill',
    link: 'https://www.linkedin.com/company/onboard-crew/',
  },
  {
    name: 'OnBoard Email',
    icon: 'ri-mail-fill',
    link: contactEmail,
  },
  {
    name: 'OnBoard WhatsApp',
    icon: 'ri-whatsapp-line',
    link: 'https://wa.me/6285311798722',
  },
];

export default function Footer({ type }) {
  const { t } = useTranslation();

  const footerNav = [
    {
      section: t('Company'),
      children: [
        {
          name: t('AboutUs'),
          link: '/about',
        },
        {
          name: t('PrivacyPolicy'),
          link: '/privacy-policy',
        },
        {
          name: t('TermsConditions'),
          link: '/terms-conditions',
        },
      ],
    },
    {
      section: t('Solutions'),
      children: [
        {
          name: t('ForCompanies'),
          link: '/companies',
        },
        {
          name: t('ForSeafarer'),
          link: '/seafarers',
        },
        {
          name: t('JobListing'),
          link: '/jobs',
        },
      ],
    },
  ];

  return (
    <footer className={`${type !== 'company' ? 'bg-primary' : 'bg-primary-darker'} mt-72 text-white`}>
      <div className='max-w-1280 w-full mx-auto px-20 desktopSmall:px-40 pt-200 ipad:pt-250'>
        <div className='mb-52 flex flex-col ipad:flex-row justify-between gap-32 ipad:gap-20'>
          <div>
            <p className='text-white max-w-full ipad:max-w-md font-semibold text-title3 ipad:text-title2 mb-16 ipad:mb-32 text-center ipad:text-left'>{t('FooterTitle')}</p>
            <p className='text-regular3 text-grey-lighter max-w-full ipad:max-w-lg font-light text-center ipad:text-left'>{t('FooterDescription')}</p>
          </div>
          <div className='flex gap-40 android:gap-52 ipad:gap-72 justify-center ipad:justify-normal'>
            {footerNav.map(({ section, children }) => {

              return (
                <div key={section} className='flex flex-col justify-center ipad:justify-normal'>
                  <p className='text-white font-semibold mb-12 text-large3 text-center ipad:text-left'>{section}</p>
                  <div className='flex flex-col gap-16'>
                    {children.map(({ name, link }) => {

                      return (
                        <Link key={name} href={link} className='text-grey-lightest font-light text-small3 ipad:text-regular3 text-center ipad:text-left'>
                          {name}
                        </Link>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className='flex flex-col ipad:flex-row items-center justify-between gap-40'>
          <div className='relative'>
            <Image
              src={LogoGreen.src}
              alt='OnBoard Company Feature'
              placeholder="blur"
              width={167}
              height={32}
              blurDataURL={LogoGreen.blurDataURL}
            />
          </div>
          <div className='flex gap-16 items-center'>
            {footerSocials.map(({ name, icon, link }) => {

              return (
                <a
                  target='_blank'
                  key={name}
                  href={name === 'OnBoard Email' ? `mailto:${link}` : link}
                  className='transition-all duration-300 hover:shadow-xl hover:-translate-y-4' 
                  aria-label={`Open ${name} in a new tab`}
                >
                  <i className={`${icon} text-white text-subtitle3`} />
                </a>
              )
            })}
          </div>
        </div>
        <div className='text-center border-t pt-20 pb-32 mt-32'>
          <p className="text-white text-small3 md:text-regular3 font-light">
            &copy; {dayjs().year()} OnBoard. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
